import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  showArrow?: boolean;
  className?: string;
  tabIndex?: number;
}
export function PrimaryButton({
  children,
  onClick,
  href,
  size = 'lg',
  fullWidth = false,
  showArrow = true,
  className = '',
  tabIndex
}: PrimaryButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  const sharedClassName = `group inline-flex items-center justify-center gap-2 ${sizeClasses} ${fullWidth ? 'w-full' : ''} rounded-xl bg-lime font-heading font-semibold uppercase tracking-wide text-bg-primary transition-all duration-200 hover:bg-lime-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary ${className}`;
  const content = <>
      {children}
      {showArrow && <ArrowRightIcon size={size === 'lg' ? 20 : 18} className="transition-transform duration-200 group-hover:translate-x-1" data-id="element-302" data-mp="gpvlys9gjdto" />}
    </>;
  if (href) {
    return <a href={href} tabIndex={tabIndex} className={sharedClassName} data-id="element-303" data-mp="pqak4s7isnel">
        {content}
      </a>;
  }
  return <button onClick={onClick} tabIndex={tabIndex} className={sharedClassName} data-id="element-304" data-mp="3u6mhxbxez58j">
      {content}
    </button>;
}